import { TypeDescription } from './type-description.js';

export function createType<Output extends TypeDescription>(options: {
  description: Omit<Output, '_output'>;
}): Output {
  return options.description as Output;
}
